// @flow

const API_BASE = process.env.REACT_APP_BRIGHTBOX_API_URL || window?.cgrConfig?.BRIGHTBOX_API_URL || 'https://api.brightbox.com';
const EVENT_BASE = process.env.REACT_APP_BRIGHTBOX_EVENT_URL || window?.cgrConfig?.BRIGHTBOX_EVENT_URL || 'https://events.brightbox.com';
const ORBIT_BASE = process.env.REACT_APP_BRIGHTBOX_ORBIT_URL || window?.cgrConfig?.BRIGHTBOX_ORBIT_URL || 'http://orbit.brightbox.com';
const CONTAINER_REGISTRY_BASE = process.env.REACT_APP_BRIGHTBOX_CR_URL || window?.cgrConfig?.BRIGHTBOX_CR_URL|| 'https://cr.brightbox.com';

export const authUrl: string = API_BASE + '/auth';
export const twoFaUrl: string = API_BASE + '/auth/two_factor';
export const accountsUrl: string = API_BASE + '/1.0/accounts';
export const usersUrl: string = API_BASE + '/1.0/users';
export const userUrl: string = API_BASE + '/1.0/user';
export const serversUrl: string = API_BASE + '/1.0/servers';
export const serverGroupsUrl: string = API_BASE + '/1.0/server_groups';
export const imagesUrl: string = API_BASE + '/1.0/images';
export const serverTypesUrl: string = API_BASE + '/1.0/server_types';
export const eventsUrl: string = API_BASE + '/1.0/events';
export const zonesUrl: string = API_BASE + '/1.0/zones';
export const lbasUrl: string = API_BASE + '/1.0/load_balancers';
export const cloudIpsUrl: string = API_BASE + '/1.0/cloud_ips';
export const firewallPoliciesUrl: string = API_BASE + '/1.0/firewall_policies';
export const firewallRulesUrl: string = API_BASE + '/1.0/firewall_rules';
export const databaseServersUrl: string = API_BASE + '/1.0/database_servers';
export const databaseSnapshotsUrl: string = API_BASE + '/1.0/database_snapshots';
export const databaseTypesUrl: string = API_BASE + '/1.0/database_types';
export const applicationsUrl: string = API_BASE + '/1.0/applications';
export const clientsUrl: string = API_BASE + '/1.0/api_clients';
export const volumesUrl: string = API_BASE + '/1.0/volumes';
export const collaborationsUrl: string = API_BASE + '/1.0/collaborations';
export const userCollaborationsUrl: string = API_BASE + '/1.0/user/collaborations';

export const eventStreamUrl: string = EVENT_BASE + '/stream';

export const orbitUrl: string = ORBIT_BASE + '/v1';
export const containerRegistryUrl: string = CONTAINER_REGISTRY_BASE;
export const containerRegistryNoScheme: string = CONTAINER_REGISTRY_BASE.replace(/^https?:\/\//, '');


export const kioskUrl: string = API_BASE + '/kiosk';
export const graphqlUrl: string = API_BASE + '/graphql';